import React, {useState} from 'react';
import Arrow from '../../../../assets/icons/arrow-down.svg';

const ContractForCarsLayout = ( {check, clientContract} ) => {
  const [isVisible, setIsVisible] = useState(false)
  const changeVisible = () => {
    setIsVisible(!isVisible)
  }

  const tableTheads = [
    'Марка', 'Модель', 'Год выпуска автомобиля', 'Номер гос. регистрации',
    'Номер свид. регистрации', 'Дата выдачи свид. регистрации',
    'VIN номер', 'Оценочная стоимость, руб.', 'Рыночная стоимость, руб.',
    'Количество', 'Сумма микрозайма, руб.', 'Сумма к возврату, руб.'
  ]

  return (
    <table className="table hover cell-limited">
      <thead className="clientContract-table-head">
        <tr>
        {
          tableTheads.map((th, ind) => (
            <th key={th+ind} className="clientContract-table-col">
              <p>{th}</p>
            </th>
          ))
        }
        </tr>
      </thead>
      <tbody className="clientContract-table-body">
      { check && clientContract.positions.map((i, ind) => (
        <tr key={i.names[0] + ind + '1'}>
          <td>
            <p>{i.names[0]}</p>
          </td>
          <td>
            <p>{i.model || '-'}</p>
          </td>
          <td>
            <p>{i.carDate}</p>
          </td>
          <td>
            <p>{i.registrationNumber || '-'}</p>
          </td>
          <td>
            <p>{i.certificateNumber || '-'}</p>
          </td>
          <td>
            <p>{i.certificateDate || '-'}</p>
          </td>
          <td>
            <p>{i.vin || '-'}</p>
          </td>
          <td>
            <p>{clientContract.totalEstimatedValue.toFixed(2)}</p>
          </td>
          <td>
            <p>{i.marketPrice.toFixed(2)}</p>
          </td>
          <td>
            <p>{i.quantity}</p>
          </td>
          <td></td>
          <td></td>
        </tr>
       ))
      }
        <tr className={'clientContract-table-row'}>
          <td colSpan={'6'} className="clientContract-table-col" >
            <p>Состояние ТС</p>
          </td>
          <td colSpan={'5'} className={`clientContract-table-col`} >
            <div className={'clientContract-table-td d-flex'}>
              <p>Дополнительное описание</p>
              <span className={`clientContract-table-col-arrow${
                isVisible ? '-up' : ''
              }`}>
                 <Arrow onClick={() => changeVisible()} />
              </span>
            </div>
          </td>
        </tr>
      { check && clientContract.positions.map((td, ind) => (
        <tr key={td.names[0] + ind + '2'} className={'clientContract-table-row'}>
          <td colSpan={'6'}>
            <div className="clientContract-table-cellContent" >
              <p>{td.stateOFTheVehicle.trim()}</p>
            </div>
          </td>
          <td  colSpan={'5'}>
            <div className={`clientContract-table-line${
              isVisible ? '-visible' : ''
            }`}>
              {td.additionalInformation}
            </div>
          </td>
        </tr>
        ))
      }
      </tbody>
      <tfoot className="clientContract-table-foot">
        {
          clientContract.positions.map((i) => (
            <tr  key={Math.random().toFixed(6)}>
              <td colSpan="7">
                <p>Итого</p>
              </td>
              <td>
                <p>
                  {clientContract.totalEstimatedValue.toFixed(2)}
                </p>
              </td>
              <td>
                <p>
                  {i.marketPrice.toFixed(2)}
                </p>
              </td>
              <td>
                <p>{check && clientContract.positions[0].quantity}</p>
              </td>
              <td>
                <p>{clientContract?.amount && clientContract.amount.toFixed(2)}</p>
              </td>
              <td>
                <p>{clientContract?.refundAmount && clientContract.refundAmount.toFixed(2)}</p>
              </td>
            </tr>
          ))
        }
      </tfoot>
    </table>
  )
}

export default ContractForCarsLayout
